import { gql } from 'apollo-angular';

export default gql`
  query page($path: String, $limit: Int = 10, $offset: Int = 0, $search: String, $tag: String, $author: String) {
    blogsGraphql(
      path: $path
      limit: $limit
      offset: $offset
      search: $search
      order: "-"
      tag: $tag
      author: $author
    ) {
      count
      entities {
        nid
        title
        fieldSubtitle
        fieldBlogMainCategory {
          entity {
            name
          }
        }
        fieldBlogSubCategory {
          entity {
            name
          }
        }
        fieldCoverImage {
          alt
          title
          entity {
            url
          }
        }
        publishedAt {
          value
        }
        fieldPageParagraph {
          entity {
            fieldReusableParagraphs {
              entity {
                __typename
                fieldWysiwygModContent {
                  value
                }
                fieldVideoCardModWistiaId
                bgImage {
                  entity {
                    url
                  }
                }
                bgImageMobile {
                  entity {
                    url
                  }
                }
                playButtonText
                showGradient
              }
            }
          }
        }
        path {
          alias
        }
        ShortenUrl
        entityMetatags {
          key
          value
        }
        entityOwner {
          fieldName
        }
        fieldCoAuthors {
          entity {
            fieldName
          }
        }
      }
    }
  }
`;
